module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0 width-auto",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Store",
      "closable": false,
      "visible": _vm.addDialog,
      "modal": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addWarehouse.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewWarehouse.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "warehouseGroup"
    }
  }, [_vm._v("Group "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseGroupLists,
      "id": "warehouseGroup",
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Group"
    },
    model: {
      value: (_vm.warehouseGroupId),
      callback: function($$v) {
        _vm.warehouseGroupId = $$v
      },
      expression: "warehouseGroupId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6 align-self-end"
  }, [_c('warehousegroupdialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse Group'),
      expression: "'Add Warehouse Group'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_warehouse_group": _vm.set_data_warehouse_group
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "warehouse"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "type": "text",
      "id": "location"
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "location"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "master"
    }
  }, [_vm._v("Is Master")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "id": "master",
      "binary": true
    },
    model: {
      value: (_vm.master),
      callback: function($$v) {
        _vm.master = $$v
      },
      expression: "master"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "master"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6 radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "city1",
      "name": "ACTIVE",
      "value": "ACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city1"
    }
  }, [_vm._v("Active")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "city1",
      "name": "INACTIVE",
      "value": "INACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city1"
    }
  }, [_vm._v("Inactive")])], 1)])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60506e87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/warehouseDialog/warehouseDialog.vue
// module id = 2264
// module chunks = 0